export const NON_EMPTY_INPUT_RE = /\S+/;
export const AVAILABLE_CUSTOM_ICONS = [
  'rwc',
  'slack',
  'skype',
  'telegram',
  'viber',
  'whatsapp',
  'facebook',
];

export const AVAILABLE_STANDARD_ICONS = [
  'sms',
  'phone',
  'email',
  'http',
];

export const SETTINGS_CATEGORIES = {
  LAUNCHER: 'app-launcher',
  AVATAR: 'avatar',
  STATUS: 'status',
  STYLES: 'app-styles',
  NOTIFICATIONS: 'notifications',
  VOICE: 'voice',
  LAYOUT: 'ui-layout',
  UI_WORKSPACE: 'ui-workspace',
  DATA_CLEANUP: 'data-cleanup',
  CONTACT_BOOK_INFO: 'contact-book-info',
  BACKUP_ENV: 'backup-env',
  /* TODO: These categories might be outdated? */
  SESSION_VIEWS: 'session-views',
  AGENT_LIST: 'agent-list',
};

export const DEFAULT_CUSTOM_AVATAR = 'adventurer-neutral';
export const DEFAULT_AVATAR_SETTINGS = {
  rounded: true,
  custom: {
    isEnabled: false,
    default: DEFAULT_CUSTOM_AVATAR,
  },
};

export const DEFAULT_NOTIFICATION_TONE_PREFIX = '/static/sound/notifications';
export const DEFAULT_NOTIFICATIONS_SETTINGS = {
  call: {
    isEnabled: true,
    link: '/static/sound/notifications/call/Harmony.mp3',
  },
  message: {
    isEnabled: true,
    onBlur: true,
    link: '/static/sound/notifications/message/Message.mp3',
  },
  notify: {
    isEnabled: true,
    link: '/static/sound/notifications/notify/Po.mp3',
  },
};

export const DEFAULT_CLEAN_UP_EXPIRE_IN_DAYS = 30;
export enum TimelineType {
  TIMELINE = 'timeline',
  BUBBLE = 'bubble',
}
